import { InjectionToken } from '@angular/core';
import { Endpoints } from '../models/configuration';

export const ENDPOINTS = new InjectionToken<Endpoints>('ENDPOINTS');
